export const EMAIL_SMTP = 'EMAIL_SMTP'
export const FILE_SHARING_AWS = 'FILE_SHARING_AWS'
//export const FILE_SHARING_DROP_BOX = 'FILE_SHARING_DROP_BOX'
//export const SMS_AWS_DEFAULT = 'SMS_AWS_DEFAULT'
//export const SMS_AWS_CUSTOM = 'SMS_AWS_CUSTOM'
//export const SMS_TWILIO = 'SMS_TWILIO'
//export const EXTERNAL = 'EXTERNAL'
